<template src="../../templates/form/farm-data-upload-form.pug" lang="pug"></template>

<script>
    import Modal from './Modal.vue'
    import $axios from '../../axios'
    import cyrillicToTranslit from 'cyrillic-to-translit-js'
    import { format } from 'date-fns'

    export default {
        name: "FarmDataUploadForm",
        components: {
            Modal
        },
        props: ['farmToUpdate'],
        data() {
            return {
                animals: [],
                inspections: [],
                format
            }
        },
        methods: {
            close() {
                this.$parent.showFarmDataUploadForm = false
            },
            removeAnimal(index) {
                this.animals.splice(index, 1)
            },
            upload() {
                let file = this.$refs.file.files[0]
                let formData = new FormData()
                formData.append('farm_data', file)
                let self = this
                $axios.post('/api/triforce/upload', formData).then(response => {
                    self.animals = response.data.animals
                    self.inspections = response.data.inspections
                })
            },
            download() {
                $axios
                    .get('/api/triforce/generate-farm-model', {
                        headers: { Accept: 'application/vnd.ms-excel' },
                        responseType: 'blob'
                    })
                    .then(response => {
                        let farmNameLat = cyrillicToTranslit().transform(this.farmToUpdate.name, '_')
                        const url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', '(model_farm_data)' + farmNameLat + '.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    })
            },
            submit() {
                $axios
                    .post(
                        '/api/triforce/commit/' + this.farmToUpdate.id,
                        { animals: this.animals, inspections: this.inspections }
                    )
                    .then(response => {
                        this.$store.commit('editFarm', response.data)
                    })
                this.close()
            }
        }
    }
</script>

<style lang="sass">
    @import '../../sass/mixin/color'
    @import '../../sass/mixin/flex'

    #farm-data-upload-modal
        .modal-container
            height: 100vh
            width: 1200px
            .modal-header
                background-color: $pc_niceyellow
                color: white
            .modal-body
                height: calc(100vh - 48px - 96px)
                form
                    overflow-y: auto
                    max-height: calc(100vh - 48px - 96px - 32px)
                    padding-right: 16px
                    .buttons-wrapper
                        @include flexbox
                        @include justify-content(center)
                        @include flex-direction(column)
                        .download, .upload
                            cursor: pointer
                            display: block
                            width: 100%
                            height: 48px
                            margin-bottom: 16px
                            @include flex-center
                            text-transform: uppercase
                            svg
                                margin-right: 8px
                            &:hover
                                span
                                    font-size: 18px
                        .download
                            background-color: $dd-strong-blue
                            color: white
                        .upload
                            position: relative
                            background-color: $c-tabe-lightgreen
                            input
                                cursor: pointer
                                width: 100%
                                height: 48px
                                position: absolute
                                z-index: 999
                                opacity: 0
                    .table-container
                        .table
                            margin-top: 16px
                            thead
                                background-color: $bleu-lighten
                                color: $text-color
                            tbody
                                tr
                                    th
                                        input
                                            max-width: 100px


</style>
